import React, { useEffect, useState, useContext, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { useIntl } from "react-intl";
// import { Input } from "@ts-digital/vrc";
import { Select, Input, DatePicker, notification, Tooltip } from "antd";
import { createNewInvoice, getReasons } from "../../../../store/actions/precog";
import moment from "moment";
import "./style.css";
import { displaySuccessToast } from "../../../../store/actions/overflowNotification";
import PartiesSearchInput from "../../../parties/searchInput";

import { openNotificationWithIcon } from "../../../../libs/utils";
import { VaporDatePicker } from "../../../vapor";
import { DATETIME_FORMATZ_FOR_API } from "../../../../constants/constants";
import { useNavigate } from "react-router-dom";
import RegistryContext from "../../../../contexts/RegistryContext";

const Option = Select.Option;

const MovementForm = ({
  formByReason,
  createReason,
  setModifiedDetail,
  sectionalError,
  setSectionalError,
  setReason,
  setReloadModal,
  newDetail,
  setNewDetail,
  setLastUpdate,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const intl = useIntl();
  const activities = useSelector((state) => state.precog.activities);
  const parties = useSelector((state) => state.parties?.getParties?.data?.results);
  const reasons = useSelector((state) => state.precog.reasons.data);
  const regimes = useSelector((state) => state.precog.vat.regimes);
  const accountingLinesList = useSelector((state) => state.precog.detailAccounts?.data?.accountingLinesByCodeApiResList);

  const registryStore = useContext(RegistryContext);
  const [selectedContact, setSelectedContact] = useState({
    id: null,
    name: null,
    vatNumber: null,
    taxId: null,
  });
  const mounted = useRef();

  useEffect(() => {
    let saleOrPurchase;
    if (typeof newDetail?.doc?.active !== "undefined") {
      if (newDetail?.doc?.active) {
        saleOrPurchase = "active";
      } else {
        saleOrPurchase = "passive";
      }
    }
    if (newDetail?.factType === "DOCUMENT" || newDetail?.factType === "GD") {
      dispatch(getReasons());
    } else {
      dispatch(getReasons(newDetail?.factType, saleOrPurchase));
    }
  }, [newDetail?.factType]);

  useEffect(() => {
    /* Ho bisogno di capire quando va fatta la create. Per cui utilizzo l'espediente
      newDetail vuoto in modo da non far partire 100 create
    */
    if ((!newDetail || Object.keys(newDetail).length === 0) && !!createReason) {
      dispatch(
        createNewInvoice({
          reasonId: createReason,
        })
      )
        .then((createdDraftId) => {
          setNewDetail({ id: createdDraftId, reasonId: createReason, soruce: "MANUAL", registrationDate: moment(new Date()) });
          //  pulisco la reason in modo che non va in loop
          setReason(null);
          dispatch(displaySuccessToast("Salvataggio avvenuto correttamente", "OK"));
          setLastUpdate(moment());
          // setto di default la registration date ad oggi
          navigate(`/precog-detail/${createdDraftId}`);
        })
        .catch((error) => {
          openNotificationWithIcon(notification, "error", "", `Si è verificato un errore: ${error}`, null, null);
        });
    }
  }, [createReason, newDetail]);

  useEffect(() => {
    setSelectedContact({
      id: null,
      name: newDetail?.customerName ? newDetail?.customerName : newDetail?.supplierName,
      vatNumber: newDetail?.customerVATNumber ? newDetail?.customerVATNumber : newDetail?.supplierVATNumber,
      taxId: newDetail?.customerTaxId ? newDetail?.customerTaxId : newDetail?.supplierTaxId,
    });
  }, [
    newDetail?.customerName,
    newDetail?.customerTaxId,
    newDetail?.customerVATNumber,
    newDetail?.supplierName,
    newDetail?.supplierVATNumber,
    newDetail?.supplierTaxId,
  ]);

  useEffect(() => {
    if (!mounted.current) {
      // set mounted to true
      mounted.current = true;
    } else {
      // do componentDidUpdate logic
      registryStore.setIsLastContactAdded(!registryStore?.isLastContactAdded);
      const lastAddedContact = parties?.[parties?.length - 1];

      setSelectedContact({
        id: lastAddedContact?.id,
        name: lastAddedContact?.description,
      });
    }
  }, [registryStore?.isLastContactAdded]);

  const customStyles = {
    background: "#f2f5f8",
    border: "1px solid #d9d9d9",
    height: "40px",
    width: "100%",
  };

  const calcNewDetails = (elementObj, value) => {
    switch (true) {
      case elementObj?.typeSpecific === "sectionalsList":
        const splitSectionalActivity = value.split("/");
        return {
          businessId: splitSectionalActivity[1],
          sectionalId: splitSectionalActivity[0],
        };
      case elementObj?.type === "text" || elementObj?.type === "select":
        return { [elementObj.source]: value };
      default:
        return typeof elementObj === "string" ? { [elementObj]: value } : value;
    }
  };

  const updateInAutoSave = (elementObj, value) => {
    setModifiedDetail(calcNewDetails(elementObj, value));
  };

  const renderOptionCustom = (typeSpecific) => {
    const optionsList = [];
    switch (typeSpecific) {
      case "reasons":
        if (reasons)
          reasons.map((el) => {
            optionsList.push(
              <Option key={typeSpecific + el.code} value={el.code}>
                {`${el.description}`}
              </Option>
            );
            return optionsList;
          });
        break;
      case "sectionalsList":
        if (!activities?.status?.ended || !activities?.data) return undefined;
        activities.data.map((el) => {
          return optionsList.push(
            <Option key={typeSpecific + el.sectionalId ? el.sectionalId : el.businessId} value={`${el?.sectionalId}/${el?.businessId}`}>
              {`${el.sectionalDescription ? el.sectionalDescription.charAt(0).toUpperCase() + el.sectionalDescription.slice(1).toLowerCase() + " -" : ""} ${
                el.businessDescription ? el.businessDescription.charAt(0).toUpperCase() + el.businessDescription.slice(1).toLowerCase() : ""
              }`}
            </Option>
          );
        });
        break;
      case "regimeList":
        if (regimes) {
          regimes.list.map((el) => {
            optionsList.push(
              <Option key={el.id} value={el.id}>
                {`${el.description ? el.description.charAt(0).toUpperCase() + el.description.slice(1).toLowerCase() : ""}`}
              </Option>
            );
            return optionsList;
          });
        }
        optionsList.push(<Option value={"MULTI"}>Multiregime</Option>);
        break;
      case "vatCollectabilityList":
        return [
          <Option key={"SPLIT_PAYMENT"} value="SPLIT_PAYMENT">
            {intl.formatMessage({ id: "preCog.header.SPLIT_PAYMENT" })}
          </Option>,
          <Option key={"DEFERRED"} value="DEFERRED">
            {intl.formatMessage({ id: "preCog.header.DEFERRED" })}
          </Option>,
          <Option key={"IMMEDIATE"} value="IMMEDIATE">
            {intl.formatMessage({ id: "preCog.header.IMMEDIATE" })}
          </Option>,
        ];
      default:
        break;
    }

    return optionsList;
  };

  const renderFormElement = (obj) => {
    switch (obj.type) {
      case "monthDate":
        return (
          <VaporDatePicker
            getPopupContainer={(trigger) => trigger.parentNode}
            value={newDetail?.[obj.source] ? moment(newDetail?.[obj.source]) : null}
            placeholder="Seleziona il mese di competenza"
            picker="month"
            format="MM-YYYY"
            id="pre-cog-detail-input-9"
            style={{ marginTop: 4, width: "100%" }}
            onChange={(value) => {
              // al BE serve la data al primo del mese, ma visualizziamo solo mese/anno
              const firstdaySelected = moment(value).startOf("month").format("YYYY-MM-DD");
              setNewDetail({
                ...newDetail,
                vatCompetencePeriod: value ? firstdaySelected : null,
              });
              setModifiedDetail(
                value ? { vatCompetencePeriod: moment(firstdaySelected).format(DATETIME_FORMATZ_FOR_API) } : { fieldsToDelete: ["vatCompetencePeriod"] }
              );
            }}
          />
        );
      case "date":
        const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
        // in alcuni casi la source è in un object.
        const splittedObjSource = obj.source.split(".");
        let BEdata = newDetail?.[splittedObjSource[0]];
        for (let i = 1; i < splittedObjSource.length; i++) {
          BEdata = BEdata[splittedObjSource[i]];
        }
        let initialDateValue = BEdata ? BEdata : obj?.value === "currentdate" ? moment(new Date()) : null;

        if (obj.source === "docDate") {
          initialDateValue = newDetail?.doc?.date ? moment(new Date(newDetail?.doc?.date)) : null;
        }
        return (
          <DatePicker
            format={dateFormatList}
            defaultValue={initialDateValue}
            id={`pre-cog-detail-date_${obj.source}`}
            style={{ marginTop: 4, width: "100%" }}
            className={"vapor-data-picker"}
            onChange={(value) => {
              updateInAutoSave(obj.source, value);
            }}
            allowClear={true}
            dropdownClassName={""}
          />
        );

      case "text":
        /** Le inconsistenze del BE costringono a questi accrocchi*/
        let initValue = newDetail?.[obj.source];
        if (obj.source === "docNumber") {
          initValue = newDetail?.doc?.number;
        }
        if (obj.source === "docDescription") {
          initValue = newDetail?.doc?.description;
        }

        return (
          <Input
            className={`pre-cog-detail-color pre-cog-detail-input${obj.source}`}
            defaultValue={initValue}
            label={useIntl().formatMessage({ id: obj.label }) + (obj.required ? " *" : "")}
            style={
              {
                /* border: errors?.docNumber ? "1px solid #d82829" : "none"*/
              }
            }
            placeholder={useIntl().formatMessage({ id: obj.label })}
            onChange={(e) => {
              updateInAutoSave(obj.source, e.target.value);
            }}
          />
        );
      case "registry":
        /** isAutomaticDisabled disabilita il campo nelle tipologie automaticamente create  */
        if (obj.isAutomaticDisabled)
          return (
            <Input
              style={{ cursor: "not-allowed" }}
              className="pre-cog-detail-input"
              value={obj.source === "client" ? newDetail?.["customerVATNumber"] : newDetail?.["supplierVATNumber"]}
              disabled={true}
            />
          );
        // supplierVATNumber

        return (
          <PartiesSearchInput
            registryStore={registryStore}
            source={obj.source}
            disabled={false}
            getPopupContainer={(trigger) => trigger.parentNode}
            selected={
              selectedContact
                ? {
                    id: selectedContact.id,
                    description: selectedContact.name,
                  }
                : null
            }
            width={"357.5px"}
            onSelect={(party) => {
              if (!party.description) return;
              setSelectedContact({
                id: party._meta?.id,
                name: party.description,
                vatNumber: party.identifiers?.[0]?.value,
                taxId: party.identifiers?.[1]?.value,
              });

              const objToSave =
                obj?.source === "client"
                  ? {
                      customerName: party.description,
                      customerTaxId: party.identifiers?.[1]?.value || party.identifiers?.[0]?.value,
                      customerVATNumber: party.identifiers?.[0]?.value,
                    }
                  : {
                      supplierName: party.description,
                      supplierTaxId: party.identifiers?.[1]?.value || party.identifiers?.[0]?.value,
                      supplierVATNumber: party.identifiers?.[0]?.value,
                    };

              updateInAutoSave(obj, objToSave);
            }}
            onClear={() => {
              setSelectedContact({
                id: null,
                name: null,
                vatNumber: null,
                taxId: null,
              });
            }}
            value={selectedContact?.name}
            placeholder={useIntl().formatMessage({ id: obj.label })}
            customStyles={customStyles}
            label={useIntl().formatMessage({ id: obj.label }) + (obj.required ? " *" : "")}
          />
        );
      case "select":
        let defaultValue;
        // se è sezionale/attività devo mergiare 2 valori
        if (obj.typeSpecific === "sectionalsList") {
          defaultValue = newDetail?.["sectionalId"] && newDetail?.["businessId"] ? newDetail?.["sectionalId"] + "/" + newDetail?.["businessId"] : null;
        } else if (obj.typeSpecific === "vatCollectabilityList") {
          defaultValue = newDetail?.vatCollectability ? intl.formatMessage({ id: `preCog.header.${newDetail.vatCollectability.toUpperCase()}` }) : undefined;
        } else if (newDetail?.[obj.source]) {
          defaultValue = newDetail?.[obj.source];
        } else if (["reasonsBankTransaction", "reasons"].includes(obj.typeSpecific) && createReason) {
          defaultValue = createReason;
        }
        /** Per il regime devo disabilitare fino a che non verifico che abbia delle linee contabili */
        let disabledSelect = false;
        if (obj.typeSpecific === "regimeList") {
          disabledSelect = accountingLinesList ? accountingLinesList.findIndex((el) => el.hasChildren) === -1 : true;
        }

        const theSelect = (
          <Select
            showSearch
            disabled={disabledSelect}
            optionFilterProp="children"
            getPopupContainer={(trigger) => trigger.parentNode}
            filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
            value={defaultValue}
            className={
              (obj.typeSpecific === "sectionalsList" ? "pre-cog-select selectSpanEllipsis" : "pre-cog-select") +
              (obj.typeSpecific === "sectionalsList" && sectionalError ? " error" : "")
            }
            placeholder={useIntl().formatMessage({ id: obj.label }) + (obj.required ? "*" : "")}
            defaultValue={defaultValue}
            onSelect={(value) => {
              if (obj.typeSpecific === "sectionalsList") setSectionalError(false);
              /** Serve tutto obj in caso di sezionale altrimenti si rompe la selezione sezionale */
              if (obj.source === "regimeId") {
                setModifiedDetail({ regimeId: value });
                setReloadModal(true);
              } else if (obj.source === "reasonId") {
                // devo ricaricare la form con i campi richiesti per la nuova reason
                setModifiedDetail({ reasonId: value });
                setReloadModal(true);
              } else {
                updateInAutoSave(obj, value);
              }
            }}
          >
            {renderOptionCustom(obj.typeSpecific)}
          </Select>
        );
        return disabledSelect ? (
          <Tooltip placement="bottom" title="Deve essere presente almeno un imponibile" color={"rgb(0, 80, 117)"}>
            {theSelect}
          </Tooltip>
        ) : (
          theSelect
        );
      default:
        return null;
    }
  };

  const formDataByReason = formByReason?.form || {};

  return (
    <div className="pre-cog-detail-header-document-grid threeGridCols" style={{ marginLeft: newDetail.reasonId === "CO1" ? "48px" : "32px" }}>
      {Object.values(formDataByReason).map((el, index) => {
        return (
          <div
            key={`formDataByReason_${index}`}
            className="precog-create-form-input-container"
            style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}
          >
            {
              /** label separata se non è input */
              ["custom", "monthDate", "date", "select", "registry", "text"].includes(el.type) && (
                <div>
                  <FormattedMessage id={el.label} /> {el.required ? "*" : ""}
                </div>
              )
            }
            {renderFormElement(el)}
          </div>
        );
      })}
    </div>
  );
};

export default MovementForm;
